module.exports = __webpack_public_path__ + "img/13.bfac54c0.jpg";